import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import history from "../../../../../global/history";
import ConfirmDeleteDialog from "../../../../../components/Modal/ConfirmDelete";
import axios from "../../../../../config/axios";
import {
  showSuccessToast,
  showValidationErrorToast,
} from "../../../../../components/Toasts";
import { useTranslation } from "react-i18next";
import InvoicePaymentsDialog from "../../../InvoicePaymentsDialog";
import InvoiceRow from "./InvoiceRow";

const InvoiceSection = ({ stay, getStay }) => {
  const [selectedDeleteInvoice, setSelectedDeleteInvoice] = useState();
  const [selectedPayInvoice, setSelectedPayInvoice] = useState();
  const [invoices, setInvoices] = useState([]);
  const [isCreatingFinalInvoice, setIsCreatingFinalInvoice] = useState(false);
  const { t } = useTranslation("dashboard");

  function getInvoices() {
    axios.get("api/v1/invoices.json?stay_id=" + stay.id).then(({ data }) => {
      setInvoices(data.entries);
    });
  }

  useEffect(() => {
    getInvoices();
  }, []);

  function deleteInvoice(invoice) {
    axios.delete(`/api/v1/invoices/${invoice.id}.json`).then(() => {
      getInvoices();
    });
  }

  function createFinalInvoice() {
    setIsCreatingFinalInvoice(true);

    axios
      .post(
        `api/v1/stays/${stay.id}/invoices/total_open_invoice_summary.json`,
        { with_local_tax: true }
      )
      .then(({ data }) => {
        history.push(`/dashboard/stays/${stay.id}/invoices/${data.id}`);
      })
      .catch(showValidationErrorToast)
      .finally(() => setIsCreatingFinalInvoice(false));
  }

  function createInvoice() {
    axios
      .post(`api/v1/invoices.json?stay_id=${stay.id}`)
      .then(function (response) {
        history.push(
          "/dashboard/stays/" + stay.id + "/invoices/" + response.data.id
        );
      });
  }

  function deleteSelectedInvoice() {
    axios.delete(`/api/v1/invoices/${selectedDeleteInvoice.id}.json`).then(
      function () {
        setSelectedDeleteInvoice(null);
        getStay();
        getInvoices();
        showSuccessToast("Erfolgreich gelöscht");
      },
      function (error) {
        console.log("error ", error.response);
      }
    );
  }

  function handlePaymentClose() {
    getInvoices();
    setSelectedPayInvoice(null);
  }

  function handlePaymentSuccess() {
    getStay();
    getInvoices();
    setSelectedPayInvoice(null);
  }

  if (!invoices) {
    return <></>;
  }

  const hasOpenAmounts =
    invoices.some(
      (invoice) => invoice.status === "unpaid" && invoice.open_amount > 0
    ) || stay.open_local_tax;

  return (
    <>
      <Card
        title={`Rechnungen`}
        footer={
          <Row>
            <Col className="d-flex">
              <Button className="mr-2" onClick={createInvoice}>
                Rechnung erstellen
              </Button>
              {/* Not finished yet */}
              {/*<Button*/}
              {/*  variant="secondary"*/}
              {/*  disabled={!hasOpenAmounts || isCreatingFinalInvoice}*/}
              {/*  onClick={createFinalInvoice}*/}
              {/*>*/}
              {/*  Abschlussrechnung erstellen*/}
              {/*</Button>*/}
            </Col>
          </Row>
        }
      >
        <div className="ui-table-container">
          <table cellSpacing="0">
            <thead>
              <tr>
                <th>Rechnung-Nr.</th>
                <th>Bezahlt / Gesamtbetrag</th>
                <th>Offen</th>
                <th>Quittung</th>
                <th>Zahlungsmethode</th>
                <th>Erstellt am</th>
                <th>Optionen</th>
              </tr>
            </thead>
            <tbody>
              {invoices?.map((invoice) => (
                <InvoiceRow
                  key={invoice.id}
                  invoice={invoice}
                  stay={stay}
                  onPaymentEdit={setSelectedPayInvoice}
                  onDelete={setSelectedDeleteInvoice}
                />
              ))}
              {invoices?.length === 0 && (
                <tr>
                  <td colSpan={6}>
                    {t("booking_details.invoice_section.empty")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      <ConfirmDeleteDialog
        show={!!selectedDeleteInvoice}
        handleClose={() => setSelectedDeleteInvoice(null)}
        handleDelete={deleteSelectedInvoice}
      />

      {selectedPayInvoice && (
        <InvoicePaymentsDialog
          invoice={selectedPayInvoice}
          handleClose={handlePaymentClose}
          handleSubmit={handlePaymentSuccess}
        />
      )}
    </>
  );
};

export default InvoiceSection;
